export default () => import(/* webpackChunkName: 'coffee/app/lucky3d' */ './Lucky3d');
